import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import IconTextButton from "../buttons/IconTextButton";
import { FLAG_ICON } from "assets/index";

interface WarningModalProps {
  open: boolean;
  onClose: () => void;
  onProceed: () => void;
  title?: string;
  description?: string;
}

const WarningModal: React.FC<WarningModalProps> = ({
  open,
  onClose,
  onProceed,
  title = "Unsaved Changes",
  description = "Note: If You have unsaved changes. all changes will be lost.",
}) => {
  return (
    <Dialog
      open={open}
      onClose={(_, reason) => {
        if (reason !== "backdropClick") {
          onClose();
        }
      }}
      slotProps={{
        backdrop: {
          sx: {
            backdropFilter: "blur(8px)",
            backgroundColor: "rgba(0,0,30,0.4)",
          },
        },
      }}
      PaperProps={{
        sx: {
          minWidth: "32%",
          maxWidth: "50%",
          maxHeight: "90vh",
          overflow: "auto",
          backgroundColor: "white",
          borderRadius: "10px",
          padding: "16px",
        },
      }}
      aria-labelledby="warning-modal-title"
      aria-describedby="warning-modal-description"
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          marginBottom: "16px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            border: "1px solid #D5D7DA",
            padding: "10px",
            borderRadius: "10px",
            boxShadow: "0px 2px rgba(0, 0, 0, 0.25)",
            marginRight: "16px",
          }}
        >
          <img src={FLAG_ICON} width={20} height={20} alt="Flag Icon" />
        </Box>
        <Typography
          variant="h6"
          fontSize={18}
          sx={{ fontWeight: "600", fontFamily: "Inter" }}
          color="rgba(24, 29, 39, 1)"
        >
          {title}
        </Typography>
        <IconButton sx={{ marginLeft: "auto" }} onClick={onClose}>
          <CloseOutlined />
        </IconButton>
      </Box>
      <DialogContent sx={{ mt: 2 }}>
        <Typography
          variant="body2"
          fontFamily={"Inter"}
          textAlign={"center"}
          fontSize={16}
          color="rgba(83, 88, 98, 1)"
        >
          {description}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            gap: 2,
          }}
        >
          <IconTextButton
            label="Cancel"
            sx={{ flex: 1 / 2 }}
            onClick={onClose}
          />
          <IconTextButton
            variant="contained"
            sx={{
              backgroundColor: "rgba(0, 0, 0, 1)",
              textTransform: "none",
              flex: 1 / 2,
              borderRadius: "8px",
              border: "none",
              fontFamily: "Inter",
              fontSize: "16px",
              fontWeight: "600",
              color: "rgba(255, 255, 255, 1)",
              "&:hover": {
                bgColor: "rgba(0, 0, 0, 1)",
                border: "none",
              },
            }}
            label="Proceed"
            onClick={onProceed}
          />
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default WarningModal;
